import {
  GET_ALL_SUBSCRIPTION,
  GET_RUNNING_SUBSCRIPTION,
  GET_SUBSCRIPTION_HISTORY,
  GET_DASHBOARD_DETAILS,
  GET_ALL_CARDS,
} from "../actions/types";

const initialState = {
  subscription: {
    docs: [],
    totalDocs: 0,
    limit: 0,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  allCards: [],
  allSubscription: {},
  runningSubscription: {},
  dashboardDetails: {},
  loading: true,
};

const subscriptionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_SUBSCRIPTION:
      return {
        ...state,
        allSubscription: payload,
        loading: false,
      };
    case GET_RUNNING_SUBSCRIPTION:
      return {
        ...state,
        runningSubscription: payload,
        loading: false,
      };
    case GET_SUBSCRIPTION_HISTORY:
      return {
        ...state,
        subscription: payload,
        loading: false,
      };
    case GET_DASHBOARD_DETAILS:
      return {
        ...state,
        dashboardDetails: payload,
        loading: false,
      };
    case GET_ALL_CARDS:
      return {
        ...state,
        allCards: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default subscriptionReducer;
